import React from "react";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import { Alert } from "@assets/icons";
// endregion Imports - Assets
// region Imports - Styles
import * as Styled from "./styles";
// endregion Imports - Styles

// region Interfaces
interface IProps {
  alertMessage: string;
  iconColor: "yellow" | "red";
}
// endregion Interfaces

const AlertContentByClient: React.FC<IProps> = ({ alertMessage, iconColor }) => (
  <Styled.Container>
    <Styled.IconContainer color={iconColor === "yellow" ? "#ffcc00" : "red"}>
      <ReactSVG src={Alert} id="svgAlert" />
    </Styled.IconContainer>
    {alertMessage}
  </Styled.Container>
);

export default AlertContentByClient;